import { Grid, Typography } from "@mui/material";
import { useAppSelector } from "../../app/store/configureStore";
import AgencyServices from "./AgencyServices";
import { ResourceIVForm } from "../../app/models/Answers";

export default function AgenciesServingChild(props: any) {
  const { onSave, answersData, onAnswerChange } = props;
  const { user } = useAppSelector((state) => state.account);

  const RCIVCommunityAgencyCodes: ResourceIVForm = {
    nameCode: 220,
    addressCode: 221,
    telephoneCode: 222,
    emailCode: 223,
    websiteCode: 224,
    agencyDetailsCode: 319,
    agencyDetailsBilingualCode: 322,
  };

  const RCIV2ndCommunityAgencyCodes: ResourceIVForm = {
    nameCode: 230,
    addressCode: 231,
    telephoneCode: 232,
    emailCode: 233,
    websiteCode: 234,
    agencyDetailsCode: 321,
    agencyDetailsBilingualCode: 320,
  };

  return (
    <Grid item mb={2} p={2}>
      <Typography fontWeight={700}>
        RC IV-3 Agencies Serving Children with Disabilities
      </Typography>

      <Grid item>
        <Typography display={user?.languageSpecialization ? "show" : "none"}>
          Agency descriptions must be provided in both English and your second
          language.
        </Typography>
      </Grid>
      <Grid item mb={2}>
        <Typography>
          Contact information and brief descriptions of two community agencies
          that provide resources and services for children with disabilities (in
          most communities, the local school district provides these services).
        </Typography>
      </Grid>
      <Grid item mb={2}>
        <AgencyServices
          onSave={onSave}
          answersData={answersData}
          onAnswerChange={onAnswerChange}
          ResourceCollectionIVCodes={RCIVCommunityAgencyCodes}
        />
      </Grid>

      <Grid item>
        <AgencyServices
          onSave={onSave}
          answersData={answersData}
          onAnswerChange={onAnswerChange}
          ResourceCollectionIVCodes={RCIV2ndCommunityAgencyCodes}
        />
      </Grid>
    </Grid>
  );
}
